<div class="fuse-card auto-width mb-12 mat-card mat-elevation-z2 p-0" [ngClass.gt-sm]="'mb-0 mr-12 p-0 m-b-6 m-r-6'">
    <div class="title-height" fxLayout="row" fxLayoutAlign="space-between center">
        <h3 class="pr-16 cardHeader">Trabajador</h3>
        <div *ngIf="!employeeService.isEmployeeLocked">
            <button mat-icon-button *ngIf="editable" (click)="openDialog()" [disabled]="isLoading" tabindex="-1">
                <mat-icon class="mat-icon material-icons mat-icon-no-color f-s-19">edit</mat-icon>
            </button>
        </div>
        <div>
            <button mat-icon-button [matMenuTriggerFor]="moreMenu2" class="navbar-toggle-button"
                *ngIf="sharedService.Permissions.HasPermisos314 || sharedService.Permissions.HasPermisos601 || sharedService.Permissions.HasPermisos614">
                <mat-icon class="mat-icon material-icons mat-icon-no-color f-s-19">more_vert</mat-icon>
            </button>

            <!-- mobile size code twise -->
            <mat-menu #moreMenu2="matMenu" [overlapTrigger]="false">
                <button mat-menu-item (click)="openEmployeeMoveDialog()" *ngIf="!employeeService.isEmployeeLocked">
                    <span>Mover a otra empresa</span>
                </button>

                <button mat-menu-item *ngIf="hasPermisionToBlock && !employeeService.isEmployeeLocked" (click)="onLockEmployeeClick()">
                    <span>Bloquear</span>
                </button>

                <button mat-menu-item *ngIf="hasPermisionToUnblock && employeeService.isEmployeeLocked" (click)="onUnlockEmployeeClick()">
                    <span>Desbloquear</span>
                </button>

                <button mat-menu-item *ngIf="sharedService.Permissions.HasPermisos601 === true && !employeeService.isEmployeeLocked"
                    (click)="onCancelEmployeeDataClick()">
                    <span>Cancelar datos</span>
                </button>

                <button mat-menu-item *ngIf="sharedService.Permissions.HasPermisos614 === true && !employeeService.isEmployeeLocked"
                    (click)="onDeleteEmployeeDataClick()">
                    <span>Eliminar trabajador</span>
                </button>
            </mat-menu>
        </div>
    </div>

    <div class="p-10 pt-0" *ngIf="isLoading == false">
        <table class="border-none">
            <caption></caption>
           <tr>
               <th></th>
           </tr>
            <tr>
                <td>
                    <span *ngIf="trabajador.sexo !== '' && trabajador.sexo !== null">
                        <span class="f-w-600">{{trabajador.sexo | titlecase }}</span> de
                    </span>
                    <span *ngIf="trabajador.age !== null && trabajador.age > 0 ">
                        <span matTooltip="{{formatedFnacimiento | date: 'dd/MM/yyyy'}}" class="f-w-600">{{trabajador.age
                            }}
                            años</span> de
                    </span>
                    <span *ngIf="trabajador.poblacion !== '' && trabajador.poblacion !== null">
                        <span matTooltipClass="formatted" matTooltip="{{formatedAddress}}">{{trabajador.poblacion |
                            titlecase}}</span>
                    </span>
                </td>
            </tr>

            <tr *ngIf="(yearDiff !=null && anoText !='') || (mesesText != null && mesesText != '')">
                <td>Antigüedad:
                    <span *ngIf="yearDiff !=null && anoText !='' " matTooltipClass="formatted"
                        matTooltip="{{BajaDateHoverText}}">{{yearDiff}} {{anoText}}</span>

                    <span *ngIf="(yearDiff != null && anoText !='') && (mesesText != null && mesesText != '')"> y
                    </span>

                    <span matTooltipClass="formatted" matTooltip="{{BajaDateHoverText}}"
                        *ngIf="mesesText != null && mesesText != '' ">{{monthDiff}} {{mesesText}}.</span>
                    <span class="color-red" matTooltipClass="formatted"
                        matTooltip="{{BajaDateHoverText}}">{{BaajaDeeText}}</span>
                </td>
            </tr>

            <tr>
                <td><span matTooltipClass="formatted" matTooltip="{{consentimentoHouverText}}"
                        *ngIf="trabajador.tipoConsentimiento != null || trabajador.consentimiento != null"><strong>{{consent}}</strong></span>
                </td>
            </tr>
        </table>

        <table class="border-none m-b-5 m-t-5">
            <caption></caption>
            <tr>
                <th></th>
            </tr>
            <tr>
                <td *ngIf="trabajador.refTrabajador != null">Ref: {{trabajador.refTrabajador}}
                </td>
                <td *ngIf="trabajador.nif != null"> NIF: {{trabajador.nif}}
                </td>
            </tr>
        </table>

        <table class="border-none">
            <caption></caption>
            <tr>
                <th></th>
            </tr>
            <tr>
                <td span *ngIf="trabajador.email != null">Email: {{trabajador.email}}
                </td>
            </tr>
        </table>

        <!-- Address -->
        <table class="border-none">
            <caption></caption>
            <tr>
                <th></th>
            </tr>
            <tr *ngIf="trabajador.direccion">
                <td>
                    <span class="align-vertical-center">
                        {{trabajador.direccion}}
                        <mat-icon *ngIf="trabajador.obsDireccion" class="inline-icon" matTooltipClass="formatted"
                            matTooltip="{{trabajador.obsDireccion}}">
                            info
                        </mat-icon>
                    </span>
                </td>
            </tr>

            <tr *ngIf="trabajador.cp || trabajador.poblacion || trabajador.provincia">
                <td>
                    <ng-container *ngIf="trabajador.cp">{{trabajador.cp}}</ng-container>
                    <ng-container *ngIf="trabajador.poblacion">
                        {{trabajador.poblacion}}
                    </ng-container>
                    <ng-container *ngIf="trabajador.provincia">
                        ({{trabajador.provincia}})
                    </ng-container>
                </td>
            </tr>
        </table>

        <table class="border-none m-t--5 m-b-5">
            <caption></caption>
            <tr>
                <th></th>
            </tr>
            <tr class="m-t-10">
                <div xFlex="100" fxFlex.gt-sm="100">
                    <div xFlex="100" fxFlex.gt-sm="50" class="max-width-100">
                        <div
                            *ngIf="trabajador.tAttr1 != null && trabajador.tAttr1 != '' && trabajador.eAttr1 != null && trabajador.eAttr1 != ''">
                            <span>{{trabajador.eAttr1 | titlecase}}:</span><span>{{trabajador.tAttr1 | titlecase}}
                            </span>
                        </div>
                        <div
                            *ngIf="trabajador.tAttr2 != null && trabajador.tAttr2 != '' && trabajador.eAttr2 != null && trabajador.eAttr2 != ''">
                            <span>{{trabajador.eAttr2 | titlecase}}:</span><span>{{trabajador.tAttr2 |
                                titlecase}}</span>
                        </div>
                        <div
                            *ngIf="trabajador.tAttr3 != null && trabajador.tAttr3 != '' && trabajador.eAttr3 != null  && trabajador.eAttr3 != ''">
                            <span>{{trabajador.eAttr3 | titlecase}}:</span> <span>{{trabajador.tAttr3 |
                                titlecase}}</span>
                        </div>
                        <div
                            *ngIf="trabajador.tAttr4 != null && trabajador.tAttr4 != '' && trabajador.eAttr4 != null  && trabajador.eAttr4 != ''">
                            <span>{{trabajador.eAttr4 | titlecase}}:</span><span>{{trabajador.tAttr4 |
                                titlecase}}</span>
                        </div>
                        <div
                            *ngIf="trabajador.tAttr5 != null && trabajador.tAttr5 != '' &&  trabajador.eAttr5 != null  && trabajador.eAttr5 != ''">
                            <span>{{trabajador.eAttr5 | titlecase}}:</span><span>{{trabajador.tAttr5 |
                                titlecase}}</span>
                        </div>
                        <div
                            *ngIf="trabajador.tAttr6 != null && trabajador.tAttr6 != '' && trabajador.eAttr6 != null  && trabajador.eAttr6 != ''">
                            <span>{{trabajador.eAttr6 | titlecase}}:</span><span>{{trabajador.tAttr6 |
                                titlecase}}</span>
                        </div>
                        <div
                            *ngIf="trabajador.tAttr7 != null && trabajador.tAttr7 != '' && trabajador.eAttr7 != null  && trabajador.eAttr7 != ''">
                            <span>{{trabajador.eAttr7 | titlecase}}:</span><span>{{trabajador.tAttr7 | titlecase}}
                            </span>
                        </div>
                        <div
                            *ngIf="trabajador.tAttr8 != null && trabajador.tAttr8 != '' && trabajador.eAttr8 != null  && trabajador.eAttr8 != ''">
                            <span>{{trabajador.eAttr8 | titlecase}}:</span><span>{{trabajador.tAttr8 | titlecase}}
                            </span>
                        </div>
                        <div
                            *ngIf="trabajador.tAttr9 != null && trabajador.tAttr9 != '' && trabajador.eAttr9 != null  && trabajador.eAttr9 != ''">
                            <span>{{trabajador.eAttr9 | titlecase}}:</span><span>{{trabajador.tAttr9 | titlecase}}
                            </span>
                        </div>
                        <div
                            *ngIf="trabajador.tAttr10 != null && trabajador.tAttr10 != '' && trabajador.eAttr10 != null  && trabajador.eAttr10 != ''">
                            <span>{{trabajador.eAttr10 | titlecase}}:</span><span>{{trabajador.tAttr10 | titlecase}}
                            </span>
                        </div>
                        <div
                            *ngIf="trabajador.tAttr11 != null && trabajador.tAttr11 != '' && trabajador.eAttr11 != null  && trabajador.eAttr11 != ''">
                            <span>{{trabajador.eAttr11 | titlecase}}:</span><span>{{trabajador.tAttr11 | titlecase}}
                            </span>
                        </div>
                        <div
                            *ngIf="trabajador.tAttr12 != null && trabajador.tAttr12 != '' && trabajador.eAttr12 != null  && trabajador.eAttr12 != ''">
                            <span>{{trabajador.eAttr12 | titlecase}}:</span><span>{{trabajador.tAttr12 | titlecase}}
                            </span>
                        </div>
                    </div>
                </div>
            </tr>
            <tr>
                <span *ngIf="trabajador.puesto !=null && trabajador.puesto !=''">Puesto: {{trabajador.puesto |
                    titlecase}}</span>
            </tr>
        </table>

        <table class="border-none m-b-5 m-t-5">
            <caption></caption>
            <tr>
                <th></th>
            </tr>
            <tr>
                <td><span *ngIf="trabajador.absentismo != null">Abs: {{trabajador.absentismo}}% </span>
                </td>
                <td><span *ngIf="trabajador.bradford != null">Bradford: {{trabajador.bradford}}</span>
                </td>
            </tr>
        </table>

        <table class="border-none m-b-5 m-t-5">
            <caption></caption>
            <tr>
                <th></th>
            </tr>
            <tr>
                <td>
                    <span *ngIf="trabajador.absentista != null"
                        [ngClass]="(trabajador.absentista == 'S')?'lbl1':''">Absentista
                    </span>
                    <span *ngIf="trabajador.citarBajaNueva != null"
                        [ngClass]="(trabajador.citarBajaNueva == 'S')?'lbl2':''">Citar
                        baja nueva
                    </span>
                    <span *ngIf="trabajador.despidoObjetivo != null"
                        [ngClass]="(trabajador.despidoObjetivo == 'S')?'lbl3':''">Art. 52D</span>
                    <span *ngIf="trabajador.puestoUrgente != null"
                        [ngClass]="(trabajador.puestoUrgente == 'S')?'lbl4':''">Urgente</span>
                </td>
            </tr>
        </table>

        <table class="border-none m-b-5 m-t-5">
            <caption></caption>
            <tr>
                <th></th>
            </tr>
            <tr>
                <span *ngIf="trabajador.obs != null">
                    <div class="container"
                        [ngClass]="{'show' : showSeemore === true,  'container' : showSeemore === false}">
                        {{trabajador.obs}}
                    </div>
                    <div class="f-r">
                        <button *ngIf="trabajador.obs.length > 153" aria-label="search" mat-icon-button=""
                            class="mat-icon-button p-0" (click)="clickSeeMore()">
                            <span class="mat-button-wrapper">
                                <mat-icon *ngIf="showSeemore === false"
                                    class="mat-icon material-icons mat-icon-no-color f-s-19" role="img"
                                    aria-hidden="true">more_horiz</mat-icon>
                                <mat-icon *ngIf="showSeemore === true"
                                    class="mat-icon material-icons mat-icon-no-color f-s-19" role="img"
                                    aria-hidden="true">more_horiz</mat-icon>
                            </span>
                            <div class="mat-button-ripple mat-ripple mat-button-ripple-round" matripple=""
                                ng-reflect-centered="true" ng-reflect-disabled="false"
                                ng-reflect-trigger="[object HTMLButtonElement]"></div>
                            <div class="mat-button-focus-overlay"></div>
                        </button>
                    </div>

                </span>
            </tr>
        </table>
    </div>

    <div *ngIf="isLoading == true" class="m-auto">
        <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
        </mat-progress-spinner>
    </div>
</div>